









































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import myTable from '../../components/table/my-table.vue'
import {GetHDDislysisDetail} from '../../api/realTime'
@Component({
    components: {myTable}
})
export default class extends AbpBase {
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    dataInfo:any = {}
    created(){
        this.getData()
    }
    async getData(){
        let res = await GetHDDislysisDetail({id:this.data.id})
        this.dataInfo = res.data
    }
    detailShow = true
    detailData = {}
    list = []
    columns = [
        {title:'时间',key:'recordTimeShow',width:180},
        {
            title:'生命体征',
            children:[
                {
                    title:'血压(mmHg)',
                    key:'systolicDiastolicPressure',
                    width:80
                },
                {
                    title:'心率(次/分)',
                    key:'heartRate',
                    width:80
                },
                {
                    title:'呼吸(次/分)',
                    key:'respiratoryRate',
                    width:80
                },
            ]               
        },
        {
            title:'机器数据',
            children:[
                {
                    title:'血流量(ml/min)',
                    key:'bloodFlow',
                    width:80
                },
                {
                    title:'静脉压(mmHg)',
                    key:'venousPressure',
                    width:80
                },
                {
                    title:'动脉压(mmHg)',
                    key:'arteriotony',
                    width:80
                },
                {
                    title:'跨膜压(mmHg)',
                    key:'transmembranePressure',
                    width:80
                },
                {
                    title:'超滤量(ml)',
                    key:'ultrafiltrationVolume',
                    width:80
                },
                {
                    title:'超滤率(ml/h)',
                    key:'ufr',
                    width:80
                },
                {
                    title:'电导度(ms/cm)',
                    key:'conductivity',
                    width:80
                },
                {
                    title:'透析液温度(ml/h)',
                    key:'dialysateTemperature',
                    width:80
                },
            ]               
        },
        {title:'肝素量(ml/h)',key:'heparin',width:80},
        {title:'定容(kg)',key:'meteredVolume',width:80},
        {title:'备注',key:'a'},
    ]
}
